"use client";

import React, { useEffect, useState } from "react";
import { useRouter } from "next/navigation";
import { Button } from "@/components/ui/button";
import { NotFoundState } from "@/components/ui/empty-states";
const TRANSLATIONS = {
  en: {
    goBackHome: "Go Back Home"
  },
  ar: {
    goBackHome: "العودة إلى الرئيسية"
  }
} as const;
type Lang = keyof typeof TRANSLATIONS;
export default function NotFoundPage() {
  const router = useRouter();
  const [lang, setLang] = useState<Lang>("en");
  useEffect(() => {
    try {
      const stored = localStorage.getItem("language") as Lang | null;
      if (stored && stored in TRANSLATIONS) {
        setLang(stored);
      }
    } catch {}
  }, []);
  const tr = TRANSLATIONS[lang];
  return <div className="flex min-h-screen flex-col items-center justify-center bg-gray-50/50 p-4" dir={lang === "ar" ? "rtl" : "ltr"}>
      <div className="w-full max-w-xl bg-white p-6 rounded-2xl border border-gray-150 shadow-sm flex flex-col items-center">
        <NotFoundState />
        <Button onClick={() => router.push("/admin/home")} className="mt-6 bg-teal-600 hover:bg-teal-700 text-white font-medium px-6 py-2 rounded-lg transition-colors shadow-sm cursor-pointer">
          {tr.goBackHome}
        </Button>
      </div>
    </div>;
}